import * as React from 'react'
import { DrawerWrapperInjectedProps, NeighborFn } from 'types'

type DrawerWrapperProps<P extends object> = {
  visibleRowIds?: string[]
  Component: React.ComponentType<P & DrawerWrapperInjectedProps>
  drawerProps: P
}

function DrawerWrapper<P extends object>({ visibleRowIds, Component, drawerProps }: DrawerWrapperProps<P>) {
  const ids = React.useMemo(() => (visibleRowIds ?? []).slice(), [visibleRowIds])

  const getNeighbors = React.useCallback<NeighborFn>(
    (rowId: string) => {
      const total = ids.length
      const index = ids.indexOf(rowId)
      if (index === -1) return { prevId: null, nextId: null, index: -1, total }
      const prevId = index > 0 ? ids[index - 1] : null
      const nextId = index < total - 1 ? ids[index + 1] : null
      return { prevId, nextId, index, total }
    },
    [ids]
  )

  return <Component {...drawerProps} getNeighbors={getNeighbors} />
}

export default React.memo(DrawerWrapper) as typeof DrawerWrapper
